function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.222.477a1.628 1.628 0 012.301 2.301L17.301 15l12.222 12.222a1.627 1.627 0 11-2.301 2.301L15 17.301 2.778 29.523a1.627 1.627 0 11-2.301-2.301L12.698 15 .477 2.778A1.627 1.627 0 112.778.477L15 12.699 27.222.477z",
  fill: "currentColor"
});

var SvgCloseBig = function SvgCloseBig(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M27.2219 0.476604C27.8575 -0.158868 28.8878 -0.158868 29.5234 0.476604C30.1589 1.11224 30.1589 2.1426 29.5233 2.77807L17.3013 15L29.5234 27.2221C30.1589 27.8575 30.1589 28.8879 29.5234 29.5233C28.8878 30.1589 27.8575 30.1589 27.2219 29.5233L14.9999 17.3014L2.77802 29.5231C2.14248 30.1587 1.11221 30.1586 0.476665 29.5231C-0.158845 28.8875 -0.15891 27.8573 0.4766 27.2217L12.6984 15L0.4766 2.77823C-0.15891 2.14276 -0.158845 1.1124 0.476665 0.476929C1.11221 -0.158542 2.14248 -0.15864 2.77802 0.476831L14.9998 12.6986L27.2219 0.476604Z' fill='currentColor' /%3E %3C/svg%3E";
export { SvgCloseBig as ReactComponent };